import { DataGrid, TextBox, Toolbar, } from "devextreme-react";
import { Column, FilterRow, HeaderFilter, Pager, Paging, Selection, Sorting } from "devextreme-react/data-grid";
import { useCallback, useEffect, useRef, useState } from "react";
import { importHistoryApi } from "../../../api/importHistoryApi";
import { Button } from "../../../components/buttons";
import { AnimationPopup, DefaultPopup } from "../../../components/modal";
import { sf_import_history_request } from "../../../models/request/import-history/sf_import_history_request";
import { mucPhaiThuApi } from "../../../api/mucPhaiThuApi";
import { showNotify } from "../../../helpers/toast";
import { Item } from "devextreme-react/toolbar";
import { sf_mucphaithu_select_byhocsinh_rq } from "../../../models/request/thu-phi/sf_mucphaithu_select_byhocsinh_rq";
import { hocSinhApi } from "../../../api/hocSinhApi";
import ThuPhiChiTiet from "../../../components/thu-phi/chi-tiet";
import { RootState } from "../../../state/reducers";
import { useSelector } from "react-redux";

type DetailModalProps = {
    title?: string,
    onClose: () => void,
    animationOf: string,
    request: sf_import_history_request
}

const EditKhoanNopModal = (props: DetailModalProps) => {
    const [dataSource, setDataSource] = useState([])
    const [showHuyChungTuConfirm, setShowHuyChungTuConfirm] = useState<boolean>(false);
    const [isShowThuPhiChiTiet, setIsShowThuPhiChiTiet] = useState<boolean>(false);
    const [sf_mucphaithu_editing, setSf_mucphaithu_editing] = useState<any>(undefined);
    const [ts_hocsinh_viewmodel, setTs_hocsinh_viewmodel] = useState<any>();
    const [ly_do_huy, set_ly_do_huy] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedRowsKey, setSelectedRowsKey] = useState<number[]>([]);
    const grid = useRef<any>();
    const { nam_hoc, dm_coso_id } = useSelector(
        (x: RootState) => x.common
    );
    const handleReloadData = async () => {
        const res = await importHistoryApi.select_by_function(props.request);
        if (res.is_success) {
            setDataSource(res.data)
        }
    }
    const onCloseForm = useCallback(() => {
        window.animationHidePopup(props.animationOf || "")
        setTimeout(() => {
            props.onClose();
        }, 500);
    }, [props.animationOf]);
    const onClose = useCallback(() => {
        window.animationHidePopup(props.animationOf || "")
        setTimeout(() => {
            setShowHuyChungTuConfirm(false);
        }, 500);
    }, [props.animationOf]);
    const handleHuyChungTuConfirm = () => {
        setShowHuyChungTuConfirm(true)
    };
    const handleHuyChungTuMultiple = async () => {
        setLoading(true)
        if (selectedRowsKey !== undefined) {
            const datasend = { sf_mucphaithu_ids: selectedRowsKey, ly_do_huy: ly_do_huy };
            const res = await mucPhaiThuApi.huy_chung_tu_multiple(datasend);
            if (res.is_success) {
                setShowHuyChungTuConfirm(false)
                setLoading(false)
                showNotify({ message: "Hủy chứng từ thành công", type: "success" })
            }
            else {
                showNotify({ message: "Hủy chứng từ không thành công", type: "warning" })
            }
        }
    };
    const handleRealoadHocSinh = async (hocSinhId: number) => {
        const datasend: sf_mucphaithu_select_byhocsinh_rq = { ts_hocsinh_id: hocSinhId, nam_hoc: nam_hoc }
        const res = await hocSinhApi.selectByIdNamHoc(datasend);
        if (res.is_success) {
            setTs_hocsinh_viewmodel(res.data);
        }
    };
    useEffect(() => {
        handleReloadData();
    }, [])
    return (
        <AnimationPopup
            width={'90%'}
            title={props.title}
            onClose={onCloseForm}
            animationOf={props.animationOf}
        >
            <div className="pop-up-form">
                <div className="col-md-12">
                    <div className="padding-top-5">
                        <DataGrid
                            keyExpr="id"
                            ref={grid}
                            dataSource={dataSource}
                            columnHidingEnabled={false}
                            columnAutoWidth={true}
                            showBorders={false}
                            showColumnLines={true}
                            showRowLines={true}
                            rowAlternationEnabled={true}
                            allowColumnResizing={true}
                            columnResizingMode={"nextColumn"}
                            hoverStateEnabled={true}
                            focusedRowEnabled={true}
                            height={window.innerHeight - 280}
                            className={"table-noborder-left table-white-space"}
                            noDataText="Không có dữ liệu"
                            wordWrapEnabled={true}
                            loadPanel={{ enabled: false }}
                            paging={{ enabled: false }}
                            selectedRowKeys={selectedRowsKey}
                            onSelectionChanged={(e) => {
                                const { selectedRowKeys } = e;
                                setSelectedRowsKey(selectedRowKeys)
                            }}
                        >
                            <Sorting mode="multiple" />
                            <Paging defaultPageSize={50} />
                            <Selection mode="multiple" showCheckBoxesMode="always"></Selection>
                            <FilterRow visible={true} />
                            <HeaderFilter visible={false} />
                            <Column
                                dataField="file_name"
                                caption="Tên file"
                                minWidth={150}
                                fixed={true}
                            ></Column>
                            <Column
                                dataField="ten_truong"
                                caption="Trường"
                                minWidth={150}
                                fixed={true}
                            ></Column>
                            <Column
                                dataField="ten_khoi"
                                caption="Khối"
                                width={100}
                            ></Column>
                            <Column dataField="ten_he" caption="Hệ" width={150}></Column>
                            <Column dataField="ten_lop" caption="Lớp" minWidth={60}></Column>
                            <Column
                                dataField="ma_hs"
                                caption="Mã học sinh"
                                minWidth={100}
                            ></Column>
                            <Column
                                dataField="ho_ten"
                                caption="Họ tên"
                                minWidth={150}
                            ></Column>
                            <Column
                                dataField="so_chung_tu"
                                caption="Số chứng từ"
                                width={150}
                                cellRender={(cell) => {
                                    return (
                                        <a
                                            id={`btnChungTu${cell.data.id}`}
                                            style={{ cursor: "pointer", color: "blue" }}
                                            onClick={async () => {
                                                setSf_mucphaithu_editing(cell.data);
                                                setTs_hocsinh_viewmodel(undefined);
                                                handleRealoadHocSinh(cell.data.ts_hocsinh_id);
                                                setIsShowThuPhiChiTiet(true);
                                            }}
                                        >
                                            {cell.data.so_chung_tu}
                                        </a>
                                    );
                                }}
                            />
                            <Column
                                dataField="noi_dung"
                                caption="Nội dung"
                                minWidth={150}
                            ></Column>
                            <Column dataField="" caption="Tổng tiền" alignment="center">
                                <Column
                                    headerFilter={{ allowSearch: false }}
                                    dataField="tong_tien_dinh_muc"
                                    caption="Định mức"
                                    width={120}
                                    format=",##0"
                                ></Column>
                                <Column
                                    headerFilter={{ allowSearch: false }}
                                    dataField="tong_tien_mien_giam"
                                    caption="Miễn giảm"
                                    width={120}
                                    format=",##0"
                                ></Column>
                                <Column
                                    headerFilter={{ allowSearch: false }}
                                    dataField="tong_tien_phai_nop"
                                    caption="Phải nộp"
                                    width={120}
                                    format=",##0"
                                ></Column>
                                <Column
                                    headerFilter={{ allowSearch: false }}
                                    dataField="tong_tien_da_nop"
                                    caption="Đã nộp"
                                    width={120}
                                    format=",##0"
                                ></Column>
                            </Column>
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={[10, 50, 200, 500]}
                                infoText="Trang {0} /{1} ({2} dòng)"
                                showInfo={true}
                            />
                        </DataGrid>
                    </div>
                </div>
                {showHuyChungTuConfirm && (
                    <DefaultPopup title="Xóa dữ liệu import" onClose={onClose}>
                        <div className="pop-up-form">
                            <div className="col-md-12">
                                <div className="form-group" style={{ minHeight: 100 }}>
                                    <div className="form-label">Lý do xóa:</div>
                                    <TextBox value={ly_do_huy}
                                        width={500}
                                        stylingMode="outlined"
                                        onValueChanged={(e) => {
                                            set_ly_do_huy(e.value || "")
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="pop-up-actions">
                            <Button type="normal" text="Đóng" icon="fa fa-times" onClick={() => { onClose() }} />{' '}
                            <Button type="danger" isLoading={loading} icon="fa fa-trash" isDisabled={ly_do_huy === ""} text="Xác nhận" onClick={handleHuyChungTuMultiple} />
                        </div>
                    </DefaultPopup>

                )}
                {isShowThuPhiChiTiet &&
                    sf_mucphaithu_editing &&
                    ts_hocsinh_viewmodel && (
                        <ThuPhiChiTiet
                            animationOf={`#btnChungTu${sf_mucphaithu_editing.id}`}
                            sf_mucphaithu={sf_mucphaithu_editing}
                            onClose={() => {
                                setIsShowThuPhiChiTiet(false);
                            }}
                            ts_hocsinh={ts_hocsinh_viewmodel}
                            nam_hoc={sf_mucphaithu_editing.nam_hoc}
                        />
                    )}
            </div>
            <div className="pop-up-actions">
                <Button type="normal" icon="fa fa-times" text="Đóng" onClick={onCloseForm}></Button>{' '}
                <Button type="danger" icon="fa fa-trash" isDisabled={selectedRowsKey.length === 0} text={`Xóa ${selectedRowsKey.length} dữ liệu`} onClick={handleHuyChungTuConfirm} />

            </div>
        </AnimationPopup>
    );
}

export default EditKhoanNopModal;
